import React from 'react'
import { GenericContainer, Strong } from '../../GlobalStyles'
import Slider from "react-slick";
import { Pad, Price, PriceButton, PriceContent, PriceImage, PriceTitle, PriceWrapper, NextArrow, PrevArrow, PriceHeader, PricePic, PriceOverlay } from './Prices.elements';
import {HiOutlineArrowLeft, HiOutlineArrowRight} from "react-icons/hi";

import test from "../../Images/Final2x.png";
import "./Fix.css";
import bg_test from "../../Images/valx.png";


function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <NextArrow onClick={onClick}> 
        <HiOutlineArrowRight size={"30px"} style={{position: "absolute", top: "15px", left: "15px", color: "#F0B83D"}}/>
      </NextArrow>
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <PrevArrow onClick={onClick}> 
        <HiOutlineArrowLeft size={"30px"} style={{position: "absolute", top: "15px", left: "15px", color: "#F0B83D"}}/>
      </PrevArrow>
    );
  }
  

const Prices = (props) => {

    const settings = {
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
            breakpoint: 1224,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
            },
            {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false
            }
            }
        ]
      };

    return (
        <React.Fragment>
            <PriceHeader>
                Our <Strong>Products</Strong>
            </PriceHeader>
            <GenericContainer nomargin large>
                <PricePic src={bg_test}/>
                <PriceOverlay />
                <Slider {...settings}>
                    {
                        props.props.Price.map(
                            x => {
                                return(
                                    <PriceWrapper>
                                        <Pad>
                                            <PriceImage src={x.BackgroundImage} />
                                            <PriceTitle>{x.Title}</PriceTitle>
                                            <Price>{x.Price}</Price>
                                            <PriceContent>{x.Description}</PriceContent>
                                            <PriceButton href={x.Link}>Order now</PriceButton>
                                        </Pad>
                                    </PriceWrapper>
                                )
                            }
                        )
                    }
                </Slider>
            </GenericContainer>
        </React.Fragment>
    )
}

export default Prices
